var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rank"},[_c('span',[_vm._v(_vm._s(_vm.text))]),_c('span',{class:{
      'rank-1': _vm.rank === 1,
      'rank-2': _vm.rank === 2,
      'rank-3': _vm.rank === 3,
      'rank-other': _vm.rank > 3,
    }},[_vm._v("\n    No."+_vm._s(_vm.rank)+"\n  ")]),(_vm.rank === 1)?_c('img',{staticClass:"rank-icon",attrs:{"src":_vm.rank1}}):_vm._e(),(_vm.rank === 2)?_c('img',{staticClass:"rank-icon",attrs:{"src":_vm.rank2}}):_vm._e(),(_vm.rank === 3)?_c('img',{staticClass:"rank-icon",attrs:{"src":_vm.rank3}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }